import React from "react";
import { useIntl } from "react-intl";

import { updateCandidateDetailsAsAdminService } from "@app/services/candidate/updateCandidateDetailsAsAdminService";

import { useToast } from "@hooks/useToast";

import { CONSENT_STATUS } from "@utils/enum";

export const useConsentDetailsCard = ({
  candidateId,
  onUpdateConsentDetails,
}) => {
  const { messages } = useIntl();
  const { showErrorToast, showSuccessToast } = useToast();

  const [isConsentDialogVisible, setIsConsentDialogVisible] =
    React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleOpenConsentDialog = () => {
    setIsConsentDialogVisible(true);
  };

  const handleCloseConsentDialog = () => {
    setIsConsentDialogVisible(false);
  };

  const handleConfirmConsent = React.useCallback(async () => {
    try {
      setIsLoading(true);

      const payload = {
        consent_status: CONSENT_STATUS.COMPLETED,
      };

      const { data: { candidate: { consent_status: nextStatus } = {} } = {} } =
        await updateCandidateDetailsAsAdminService(candidateId, payload);

      onUpdateConsentDetails(prev => ({ ...prev, consentStatus: nextStatus }));

      showSuccessToast();
    } catch {
      showErrorToast(messages.exception_error_message);
    } finally {
      setIsLoading(false);

      handleCloseConsentDialog();
    }
  }, [
    candidateId,
    messages.exception_error_message,
    onUpdateConsentDetails,
    showErrorToast,
    showSuccessToast,
  ]);

  return {
    handleCloseConsentDialog,
    handleConfirmConsent,
    handleOpenConsentDialog,
    isConsentDialogVisible,
    isLoading,
  };
};
